import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BroadcastService",
  controller: "Task",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "GetItemById",
  "GetPageContentByConditions",
  "FindByConditions"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const TaskApi = ZJApi.defineNewApi("TaskApi", factory);

export default TaskApi;
